"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionTile = void 0;
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var Pictogram_1 = require("../Pictogram");
var ActionTile = function (props) {
    return (React.createElement("div", { className: "action-tile" },
        props.pictogram && (React.createElement(Pictogram_1.Pictogram, { name: props.pictogram, alt: "" })),
        props.title &&
            React.createElement("h3", { className: "action-tile__heading" }, props.title),
        props.description &&
            React.createElement("p", null, props.description),
        React.createElement("div", { className: (0, classnames_1.default)('action-tile__footer', { 'action-tile__footer--divider': props.divider }) }, props.hyperLink && props.hyperLinkText &&
            React.createElement("a", { className: "action-tile__footer__link", href: props.hyperLink }, props.hyperLinkText))));
};
exports.ActionTile = ActionTile;
exports.ActionTile.propsTypes = {
    description: PropTypes.string,
    divider: PropTypes.bool,
    hyperLink: PropTypes.string,
    hyperLinkText: PropTypes.string,
    id: PropTypes.string.isRequired,
    pictogram: PropTypes.string,
    title: PropTypes.string,
};
